import type { LocalSession } from "./session"

export const PAID_MESSAGING_UPGRADE_COPY = "Coming soon."

export function canUsePaidMessagingFromSession(session: LocalSession | null | undefined): boolean {
    return Boolean(session?.canUsePaidMessaging)
}

